import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SoftBox from "./SoftBox";
import SoftTypography from "./SoftTypography";
import { formatKey } from "utils";
import { useState } from "react";
import { CircularProgress } from "@mui/material";

// Placeholder values such as { name: "", fid: "" } mean "nothing selected"
const isEmptyValue = (val) =>
  val == null ||
  val === "" ||
  (typeof val === "object" && Object.values(val).every((v) => v === ""));

const isSameOption = (option, val) => {
  if (typeof option !== "object" || typeof val !== "object")
    return option === val;
  const key = ["fid", "id"].find((k) => option?.[k] && val?.[k]);
  return key
    ? option[key] === val[key]
    : JSON.stringify(option) === JSON.stringify(val);
};

export default function AutoCompleteOption({
  options = [{ label: "", id: "" }],
  getOptionLabel,
  setOption = () => {},
  onSelect = () => {},
  fetcher = async () => {},
  value: [key, val] = ["", { label: "" }],
  size = "medium",
  noLabel = false,
  width,
  placeholder,
  noFetcher = false,
  groupBy = () => {},
  filterOptions,
}) {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const fetchOptionData = async () => {
    if (options.length !== 0 || noFetcher) return setOpen(true);
    setLoading(true);
    const res = await fetcher();
    if (res) {
      setLoading(false);
      setOption(res?.data || res);
      setOpen(true);
    }
  };

  return (
    <SoftBox sx={{ width: width || "100%" }}>
      {!noLabel && (
        <SoftBox mb={0.5} ml={0.5}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            {key && formatKey(key)}
          </SoftTypography>
        </SoftBox>
      )}
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        size={size}
        groupBy={groupBy}
        getOptionLabel={getOptionLabel}
        open={open}
        onOpen={() => fetchOptionData()}
        onClose={() => setOpen(false)}
        options={options}
        filterOptions={filterOptions}
        onChange={(e, newVal) => onSelect(e, newVal, key)}
        value={isEmptyValue(val) ? null : val}
        isOptionEqualToValue={isSameOption}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            inputProps={{ ...params.inputProps, placeholder }}
          />
        )}
      />
    </SoftBox>
  );
}
